import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableToolbarDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    }
});

export const useStyles = ({
    controlHeights,
    spaces
}: DataTableToolbarDynamicStyleType) => {
    const styles = {
        container: {
            minHeight: controlHeights.small + spaces.spacingMd * 2,
            paddingHorizontal: spaces.spacingMd,
            paddingVertical: spaces.spacingMd,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
